// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { dateRangeStyles } from "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchFieldDateRange";
import { mergeWithCss, xScreen } from "@werner/XDL/Utilities";
import { css } from "styled-components";

dateRangeStyles.datePickersWrapper = {
    css: css`
        display: flex;
        ${xScreen("lte", "sm")} {
            flex-direction: column;
            gap: 20px;
        }
    `,
};

dateRangeStyles.fromDate = {
    cssOverrides: {
        inputSelect: css`
            width: 100%;
        `,
        formField: css`
            padding-right: 10px;
            ${xScreen("lte", "sm")} {
                padding-right: 0;
            }
        `,
    },
};

dateRangeStyles.toDate = {
    cssOverrides: {
        inputSelect: css`
            width: 100%;
        `,
        formField: css`
            padding-left: 10px;
            ${xScreen("lte", "sm")} {
                padding-left: 0;
            }
        `,
    },
    labelProps: {
        color: "common.white",
    },
};
